import React from 'react';
import SvgIcon from './svgIcon';

const SvgCircleSuccessSolid = props => {
  return (
    <SvgIcon width={47} height={47} {...props}>
      <g fill="currentColor">
        <defs>
          <mask id="m0">
            <path d="M0,14.5a14.5,14.5 0 1,0 29,0a14.5,14.5 0 1,0 -29,0" transform="translate(8.999 9)" fill="white"/>
            <path d="m18.455 6-9.938 9.938L4 11.421" stroke="black" strokeLinecap="round" strokejoincap="round" fill="none" strokeWidth="3px" transform="translate(12.412 13.5)"/>
          </mask>
        </defs>
        <g mask="url(#m0)">
          <path d="M0,14.5a14.5,14.5 0 1,0 29,0a14.5,14.5 0 1,0 -29,0" transform="translate(8.999 9)"/>
        </g>
      </g>
    </SvgIcon>
  );
};

export default SvgCircleSuccessSolid;
